import React from 'react';
import PropTypes from 'prop-types';

class SignalTypeBadges extends React.Component {
  render() {
    return (
      <span>
        {this.props.signalTypes.map(signalType =>
          <span key={signalType} className="badge badge-secondary">{signalType}</span>
        )}
      </span>
    );
  }
}

SignalTypeBadges.propTypes = {
  signalTypes: PropTypes.array.isRequired
};

export default SignalTypeBadges;
